import { getToken, setToken } from './Token';
import { store } from '../redux/storeConfig/store';
import { history } from '../history';

// console.log('url', window.location.href);

const randomID = () => {
  return Math.random().toString(36).substr(2);
};

const _temporaryToken = randomID();

const getJWTViaTemporaryToken = (temporaryToken) => {
  if (_temporaryToken === temporaryToken) {
    return getToken();
  }
  return '';
};

export const setJWT = (jwt) => {
  setToken(jwt);
  store.dispatch({
    type: 'LOGIN_WITH_JWT',
    payload: { loggedInUser: jwt, loggedInWith: 'jwt' },
  });
};

window.addEventListener('message', (event) => {
  // console.log('new message', event);
  window.lastMessage = event;
  if (event.source !== window && event.origin.endsWith('.boltinsight.com')) {
    try {
      const data = JSON.parse(event.data);
      if (data.type === 'getJWTViaTemporaryToken') {
        const temporaryToken = data.temporaryToken;
        const jwt = getJWTViaTemporaryToken(temporaryToken);
        const response = { type: 'setJWT', jwt };
        // console.log('sending response', response)
        event.source.postMessage(JSON.stringify(response), '*');
        // console.log('sent!')
      } else if (data.type === 'setJWT') {
        const jwt = data.jwt;
        setJWT(jwt);
        if (window.redirectPath) {
          history.replace(window.redirectPath);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }
});

if (window.opener) {
  // console.log('hi I will send a message');
  const url = new URL(window.location.href);
  const temporaryToken = url.searchParams.get('tt');
  if (temporaryToken) {
    // console.log('temp token', temporaryToken);
    url.searchParams.delete('tt');
    const request = { type: 'getJWTViaTemporaryToken', temporaryToken };
    // console.log('sending message', request)
    window.opener.postMessage(JSON.stringify(request), '*');
    window.redirectPath = url.pathname;
  }
}

window.getJWTViaTemporaryToken = getJWTViaTemporaryToken;

export default _temporaryToken;
